import { Injectable } from '@angular/core';
import { RouteIds, Step } from '../../types';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { StepDefinitionStrategy } from './step-definition.strategy';

/**
 * Step definition service for the Confirmation step
 */
@Injectable({
  providedIn: 'root',
})
export class ConfirmationStepDefinitionService implements StepDefinitionStrategy {
  getStepDefinition(): Step {
    return {
      id: RouteIds.confirmation,
      title: $localize`3. Confirmation`,
      subtitle: $localize`Thank you for booking`,
      previousStep: () => RouteIds.yourInformation,
      googleAnalyticsEvent: GoogleAnalyticsEventEnum.Confirmation,
    };
  }
}
